module.exports = __webpack_public_path__ + "static/media/newsite.7c2526e2.md";